type NormalizeOptions = {
  decimals?: number;
  roundToNearest?: number; // e.g., 0.5, 0.25, etc.
};

export const normalizeValue =
  (options: NormalizeOptions = {}) =>
  (value: any) => {
    if (typeof value !== 'number') return value;

    const decimals = options.decimals != null && options.decimals >= 0 ? options.decimals : 2;

    let result = value;

    if (options.roundToNearest) {
      const step = options.roundToNearest;
      result = Math.round(result / step) * step;
    }

    const factor = Math.pow(10, decimals);
    return Math.round(result * factor) / factor;
  };
